import Header from './components/Header';
import Hero from './components/Hero';
import AppSection from './components/AppSection';
import CommentsSection from './components/CommentsSection';
import CardsSection from './components/CardsSection';
import FAQSection from './components/FAQSection';
import MediaSection from './components/MediaSection';
import UpdatesSection from './components/UpdatesSection';
import IndexSection from './components/IndexSection';
import CarouselSection from './components/CarouselSection';
import TopicsSection from './components/TopicsSection';
import ContactSection from './components/ContactSection';
import RankingSection from './components/RankingSection';
import AboutSection from './components/AboutSection';
import FeaturesSection from './components/FeaturesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <AppSection />
        <CommentsSection />
        <CardsSection />
        <FAQSection />
        <MediaSection />
        <UpdatesSection />
        <IndexSection />
        <CarouselSection />
        <TopicsSection />
        <ContactSection />
        <RankingSection />
        <AboutSection />
        <FeaturesSection />
      </main>
      <Footer />
    </>
  );
}